import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GridRefreshService {

  private gridRefreshSource = new Subject<any>();

  gridRefresh$ = this.gridRefreshSource.asObservable();

  refreshGridData() {
    this.gridRefreshSource.next();
  }
}
